import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/booking";

export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const Delete = async (values) => {
  return await axiosInstance(options).post(`${path}/delete`, values);
};

export const Details = async (id) => {
  return await axiosInstance(options).get(`${path}/details?o_id=${id}`);
};

export const Status = async (values) => {
  return await axiosInstance(options).post(`${path}/change-status`, values);
};

export const RescheduleBooking = async (values) => {
  return await axiosInstance(options).post(`${path}/reschedule`, values);
};

export const History = async (bookingId) => {
  const formData = new FormData();
  formData.append("booking_id", bookingId);
  return await axiosInstance(options).post(`${path}/history`, formData);
};

export const GetConsultationInvoice = async (id) => {
  return await axiosInstance(options).get(`${path}/invoice/${id}`);
};
